import React from 'react'

const Manual_Testing = () => {
  return (
    <div>
        {/* collapseThirtyOne */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingThirtyOne">
                <button 
                    className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" 
                    type="button" 
                    data-bs-toggle="collapse" 
                    data-bs-target="#collapseThirtyOne" 
                    aria-expanded="false" 
                    aria-controls="collapseThirtyOne"
                >
                    Manual Testing
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div 
                id="collapseThirtyOne" 
                className="accordion-collapse collapse" 
                aria-labelledby="headingThirtyOne" 
                data-bs-parent="#accordionCourses"
            >
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>1) Introduction to Testing:</strong>
                    <ul>
                        <li>Introduction</li>
                        <li>Importance of Software Testing</li>
                        <li>How to Conduct Software Testing</li>
                        <li>Basic Terminology of Software Testing</li>
                        <li>Manual Testing Process</li>
                        <li>Difference between Manual and Automated Testing</li>
                        <li>Software Testing Roles and Responsibilities</li>
                        <li>Static Testing and Dynamic Testing</li>
                        <li>Quality Assurance and Quality Control</li>
                        <li>Bug / Defect Life Cycle, Priority and Severity</li>
                        <li>Difference between Priority & Severity</li>
                    </ul>

                    <strong>2) Life Cycle:</strong>
                    <ul>
                        <li>Introduction</li>
                        <li>SDLC - Software Development Life Cycle</li>
                        <li>STLC - Software Testing Life Cycle</li>
                        <li>Phases of STLC</li>
                        <li>Difference between SDLC and STLC</li>
                    </ul>

                    <strong>3) Models:</strong>
                    <ul>
                        <li>Waterfall Model</li>
                        <li>Increment Model</li>
                        <li>Spiral Model</li>
                        <li>V Model</li>
                        <li>Agile Model</li>
                        <li>Scrum Framework</li>
                    </ul>

                    <strong>4) Levels and Types of Testing:</strong>
                    <ul>
                    <li>Levels of Testing
                        <ul>
                            <li>Unit Testing</li>
                            <li>Integration Testing</li>
                            <li>System Testing</li>
                            <li>Acceptance Testing</li>
                        </ul>
                    </li>
                    <li>Types of Testing
                        <ul>
                            <li><strong>Functional Testing:</strong>
                                <ul>
                                    <li>White Box Testing</li>
                                    <li>Black Box Testing</li>
                                    <li>Grey Box Testing</li>
                                    <li>Alpha Testing</li>
                                    <li>Beta Testing</li>
                                    <li>Component Testing</li>
                                    <li>Regression Testing</li>
                                    <li>Sanity Testing</li>
                                    <li>Smoke Testing</li>
                                    <li>Exploratory Testing</li>
                                </ul>
                            </li>
                            <li><strong>Non - Functional Testing:</strong>
                                <ul>
                                    <li>Load Testing</li>
                                    <li>Stress Testing</li>
                                    <li>Security Testing</li>
                                    <li>Reliability Testing</li>
                                    <li>Compatibility Testing</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>

                <strong>5) Software Test Design Techniques:</strong>
                <ul>
                    <li>Boundary Value Analysis (BVA)</li>
                    <li>Equivalence Class Partitioning (ECP)</li>
                    <li>Decision Table Based Testing Technique</li>
                    <li>State Transition Testing</li>
                    <li>Code Coverage</li>
                    <li>Statement Coverage</li>
                    <li>Condition Testing</li>
                </ul>

                <strong>6) Introduction to Mobile Testing:</strong>
                <ul>
                    <li>What is Mobile Testing?</li>
                    <li>Why is Mobile Testing Important?</li>
                    <li>What Do You Need to Know to Be a Good Mobile Tester?</li>
                    <li>Mobile Application SDLC</li>
                    <li><strong>Mobile Application Types:</strong>
                        <ul>
                        <li>Mobile App</li>
                        <li>Native Apps</li>
                        <li>Developer Tools</li>
                        </ul>
                    </li>
                    <li>Mobile Test Strategy Planning</li>
                    <li><strong>Mobile Testing Tools</strong>
                        <ul>
                        <li>Simulators</li>
                        <li>Emulators</li>
                        <li>Remote Data Access</li>
                        </ul>
                    </li>
                    <li>Mobile Testing Scoping</li>
                    <li><strong>Mobile Testing Techniques</strong>
                        <ul>
                        <li>Exploratory Testing</li>
                        <li>Device Access</li>
                        <li>Security Testing</li>
                        <li>Testing</li>
                        <li>Test Automation</li>
                        <li>Network Testing</li>
                        <li>Performance Testing</li>
                        <li>Compatibility Testing</li>
                        <li>Risk Management</li>
                        </ul>
                    </li>
                </ul>

                <strong>7) Documents and Reports:</strong>
                <ul>
                    <li>How to Create Test Plan</li>
                    <li>How to Create Test Cases</li>
                    <li>How to Create Test Suite</li>
                    <li>How to Create Test Scenario</li>
                </ul>
                </div>
            </div>
        </div>

    </div>
  )
}

export default Manual_Testing